// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "13ae6c99d8a0";
export const BUILD_VERSION_NUMBER = 47;
